import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useInstantSearch, useCurrentRefinements, Configure } from 'react-instantsearch';
import { InfinitePagination } from '@grandvisionhq/common';
import { useIsClient } from '@grandvisionhq/lib-utils-react';
import { useIntl } from '@grandvisionhq/state';
import '@grandvisionhq/analytics';
import { useItemsToClear } from '../Algolia/hooks/use-items-to-clear.js';
import '../types.js';
import 'lodash/orderBy';
import '@grandvisionhq/forms';
import '@grandvisionhq/icons';
import 'classnames';
import 'lodash/uniqBy';
import '@grandvisionhq/elements';
import '@grandvisionhq/utils';
import { useAlgoliaConfig } from '../Algolia/AlgoliaConfig.js';
import 'motion/react';
import 'algoliasearch/lite';
import 'react-dom/server';
import 'lodash/merge';
import '../Algolia/utils/query-string.js';
import { useAlgoliaData } from '../Algolia/AlgoliaDataProvider.js';
import '../Algolia/AlgoliaAnalytics.js';
import '@grandvisionhq/products';
import '../CrossSellProducts/utils/create-algolia-filters.js';

const ConnectedInfinitePagination = ({ labelKey  })=>{
    var ref3, ref1;
    const isMounted = useIsClient();
    const { searchState , setIndexUiState  } = useAlgoliaData();
    const { results: { nbHits: total  } , status ,  } = useInstantSearch();
    const isLoading = status === 'loading';
    const { getLabel  } = useIntl();
    const { pageSize  } = useAlgoliaConfig();
    const { items  } = useCurrentRefinements();
    const itemsFiltered = useItemsToClear(items);
    const itemsFilteredRef = React.useRef(itemsFiltered);
    var ref2;
    const [length, setLength] = React.useState((ref2 = (ref3 = searchState.configure) === null || ref3 === void 0 ? void 0 : ref3.length) !== null && ref2 !== void 0 ? ref2 : pageSize);
    React.useEffect(()=>{
        // In order to not make excessive calls to Algolia, we only want to run this when
        // page > 1. Additionally, we cannot trust page number from Algolia state, as our page
        // number is derived from length and offsets, so we use page querystring for this.
        const url = new URL(window.location.href);
        var ref;
        const page = (ref = Number(url.searchParams.get('page'))) !== null && ref !== void 0 ? ref : 1;
        if (itemsFiltered.length !== itemsFilteredRef.current.length && page > 1) {
            setIndexUiState((prev)=>swcHelpers.objectSpread({}, prev, {
                    configure: swcHelpers.objectSpread({}, prev.configure, {
                        length: pageSize,
                        offset: 0,
                        page: 1
                    })
                })
            );
            setLength(pageSize);
        }
        itemsFilteredRef.current = itemsFiltered;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        itemsFiltered
    ]);
    const handleClick = ()=>{
        const newLength = length + pageSize;
        setLength(newLength);
        /**
     * Configure component from algolia does not trigger algolia state changes,
     * so we have to do it ourselves. State change is needed for refinements to be converted
     * to URL query string params.
     */ setIndexUiState((prev)=>swcHelpers.objectSpread({}, prev, {
                configure: swcHelpers.objectSpread({}, prev.configure, {
                    length: newLength
                })
            })
        );
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isMounted ? /*#__PURE__*/ React.createElement(Configure, {
        offset: 0,
        length: length
    }) : null, /*#__PURE__*/ React.createElement(InfinitePagination, {
        onClick: handleClick,
        buttonLabel: getLabel('search.loadMore'),
        labelKey: labelKey !== null && labelKey !== void 0 ? labelKey : 'search.pagingStatus',
        loaded: length,
        isLoading: isLoading,
        total: total,
        pageNr: (ref1 = searchState.configure) === null || ref1 === void 0 ? void 0 : ref1.page
    }));
};

export { ConnectedInfinitePagination };
//# sourceMappingURL=InfinitePagination.js.map
